import { AppletOptions } from '@artup/client'
import pkg from '../package.json'
import components from './components'
import routes from './routes'
import { useCommonStore } from './store'
import './applet.css'

export * from './components'
export * from './store'

/**
 * Returns Common applet definition
 * @returns {AppletOptions}
 */
export function useCommonApplet () {
  const { name, version, description } = pkg
  const store = useCommonStore()
  return new AppletOptions({
    id: 'common',
    name,
    version,
    description,
    components,
    routes,
    store
  })
}
